var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdCard5989704(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id-card_5989704",
    transform: "translate(-4 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 120,
    height: 80,
    rx: 4,
    transform: "translate(4 24)",
    fill: "#ed93bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M12,32H116V96H12Z",
    fill: "#f4efea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(34 44)",
    fill: "#ff8e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M44,64A20,20,0,0,0,24,84H64A20,20,0,0,0,44,64Z",
    fill: "#ff8e9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M104,53.75a1.75,1.75,0,0,0,0-3.5H72a1.75,1.75,0,0,0,0,3.5Z",
    fill: "#4c5659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M104,61.75a1.75,1.75,0,1,0,0-3.5H72a1.75,1.75,0,0,0,0,3.5Z",
    fill: "#4c5659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M104,69.75a1.75,1.75,0,0,0,0-3.5H72a1.75,1.75,0,0,0,0,3.5Z",
    fill: "#4c5659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M104,77.75a1.75,1.75,0,0,0,0-3.5H72a1.75,1.75,0,0,0,0,3.5Z",
    fill: "#4c5659"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard5989704);
export default __webpack_public_path__ + "static/media/id-card_5989704.31f639274115ddc59971db8964565477.svg";
export { ForwardRef as ReactComponent };